<template lang="pug">
.duplicate-photos-overlay( v-if="photos.length" @click.self="close" )
  .duplicate-photos-modal
    h3 Эти фото уже были загружены ранее ({{ photos.length }})
    p.hint Они не сохранены в отчёт

    .carousel
      button.carousel-nav.prev( v-if="photos.length > 1" aria-label="Предыдущее фото" @click="prev" ) ‹

      .carousel-viewport( @touchstart="onTouchStart" @touchend="onTouchEnd" )
        img( :src="urlFor(photos[current])" )

      button.carousel-nav.next( v-if="photos.length > 1" aria-label="Следующее фото" @click="next" ) ›

    .carousel-dots( v-if="photos.length > 1" )
      span.dot(  v-for="(photo, i) in photos" :key="i" :class="{ active: i === current }" @click="current = i" )

    p.filename {{ photos[current].fileName }}

    button.close-btn( @click="close" ) Понятно
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { config } from './_helpers/config';

export default {
  name: 'DuplicatePhotosModal',

  data() {
    return {
      current: 0,
      touchStartX: 0,
    }
  },

  computed: {
    ...mapState('pointreport', ['duplicatesPhoto']),

    photos() {
      return this.duplicatesPhoto
    },
  },

  methods: {
    ...mapMutations('pointreport', ['clearDublicatesPhoto']),

    urlFor(photo) {
      return config.temp(photo.uuid, photo.extension)
    },

    next() {
      this.current = (this.current + 1) % this.photos.length
    },

    prev() {
      this.current = (this.current - 1 + this.photos.length) % this.photos.length
    },

    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].clientX
    },

    onTouchEnd(e) {
      const dx = e.changedTouches[0].clientX - this.touchStartX
      if (Math.abs(dx) < 40) return
      dx < 0 ? this.next() : this.prev()
    },

    close() {
      this.current = 0
      this.clearDublicatesPhoto()
    },
  },
}
</script>

<style scoped>
.duplicate-photos-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.duplicate-photos-modal {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  max-width: 500px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
}
.hint {
  color: #888;
  font-size: 13px;
  margin-bottom: 12px;
}
.carousel {
  display: flex;
  align-items: center;
  gap: 8px;
}
.carousel-viewport {
  flex: 1;
  aspect-ratio: 1;
  border-radius: 10px;
  overflow: hidden;
  background: #f2f2f2;
  touch-action: pan-y;
}
.carousel-viewport img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
.carousel-nav {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #f2f2f2;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.carousel-nav:active {
  background: #e0e0e0;
}
.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 12px;
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ddd;
  cursor: pointer;
}
.dot.active {
  background: #666;
}
.filename {
  text-align: center;
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  word-break: break-all;
}
.close-btn {
  display: block;
  width: 100%;
  margin-top: 16px;
  padding: 10px;
  border: none;
  border-radius: 8px;
  background: #333;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
</style>